let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6Vxrf")).then(() => parcelRequire('iLOb4'));